"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionStore = void 0;
exports.CollectionStore = [
    {
        inputs: [
            {
                internalType: 'address',
                name: '_owner',
                type: 'address'
            },
            {
                internalType: 'contract IERC20',
                name: '_acceptedToken',
                type: 'address'
            },
            {
                internalType: 'address',
                name: '_feeOwner',
                type: 'address'
            },
            {
                internalType: 'uint256',
                name: '_fee',
                type: 'uint256'
            }
        ],
        stateMutability: 'nonpayable',
        type: 'constructor'
    },
    {
        anonymous: false,
        inputs: [
            {
                components: [
                    {
                        internalType: 'contract IERC721CollectionV2',
                        name: 'collection',
                        type: 'address'
                    },
                    {
                        internalType: 'uint256[]',
                        name: 'ids',
                        type: 'uint256[]'
                    },
                    {
                        internalType: 'uint256[]',
                        name: 'prices',
                        type: 'uint256[]'
                    },
                    {
                        internalType: 'address[]',
                        name: 'beneficiaries',
                        type: 'address[]'
                    }
                ],
                indexed: false,
                internalType: 'struct CollectionStore.ItemToBuy[]',
                name: '_itemsToBuy',
                type: 'tuple[]'
            }
        ],
        name: 'Bought',
        type: 'event'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'userAddress',
                type: 'address'
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'relayerAddress',
                type: 'address'
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'functionSignature',
                type: 'bytes'
            }
        ],
        name: 'MetaTransactionExecuted',
        type: 'event'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address'
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address'
            }
        ],
        name: 'OwnershipTransferred',
        type: 'event'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: '_oldFee',
                type: 'uint256'
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_newFee',
                type: 'uint256'
            }
        ],
        name: 'SetFee',
        type: 'event'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_oldFeeOwner',
                type: 'address'
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_newFeeOwner',
                type: 'address'
            }
        ],
        name: 'SetFeeOwner',
        type: 'event'
    },
    {
        inputs: [],
        name: 'BASE_FEE',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'acceptedToken',
        outputs: [
            {
                internalType: 'contract IERC20',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'contract IERC721CollectionV2',
                        name: 'collection',
                        type: 'address'
                    },
                    {
                        internalType: 'uint256[]',
                        name: 'ids',
                        type: 'uint256[]'
                    },
                    {
                        internalType: 'uint256[]',
                        name: 'prices',
                        type: 'uint256[]'
                    },
                    {
                        internalType: 'address[]',
                        name: 'beneficiaries',
                        type: 'address[]'
                    }
                ],
                internalType: 'struct CollectionStore.ItemToBuy[]',
                name: '_itemsToBuy',
                type: 'tuple[]'
            }
        ],
        name: 'buy',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [],
        name: 'domainSeparator',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'userAddress',
                type: 'address'
            },
            {
                internalType: 'bytes',
                name: 'functionSignature',
                type: 'bytes'
            },
            {
                internalType: 'bytes32',
                name: 'sigR',
                type: 'bytes32'
            },
            {
                internalType: 'bytes32',
                name: 'sigS',
                type: 'bytes32'
            },
            {
                internalType: 'uint8',
                name: 'sigV',
                type: 'uint8'
            }
        ],
        name: 'executeMetaTransaction',
        outputs: [
            {
                internalType: 'bytes',
                name: '',
                type: 'bytes'
            }
        ],
        stateMutability: 'payable',
        type: 'function'
    },
    {
        inputs: [],
        name: 'fee',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'feeOwner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'getChainId',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256'
            }
        ],
        stateMutability: 'pure',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'contract IERC721CollectionV2',
                name: '_collection',
                type: 'address'
            },
            {
                internalType: 'uint256',
                name: '_itemId',
                type: 'uint256'
            }
        ],
        name: 'getItemBuyData',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256'
            },
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'user',
                type: 'address'
            }
        ],
        name: 'getNonce',
        outputs: [
            {
                internalType: 'uint256',
                name: 'nonce',
                type: 'uint256'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_newFee',
                type: 'uint256'
            }
        ],
        name: 'setFee',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_newFeeOwner',
                type: 'address'
            }
        ],
        name: 'setFeeOwner',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address'
            }
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    }
];
//# sourceMappingURL=CollectionStore.js.map